import { createAuthClient } from 'better-auth/react'

const authBaseURL =
  typeof window !== 'undefined' ? window.location.origin : undefined

export const authClient = createAuthClient(
  authBaseURL ? { baseURL: authBaseURL } : {}
)

export const { useSession, signIn, signOut } = authClient
